var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookRedesign = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 30 30"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#3B5998",
  fillRule: "evenodd",
  d: "M15 30c8.284 0 15-6.716 15-15S23.284 0 15 0 0 6.716 0 15s6.716 15 15 15",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M12 12.815h1.464v-.182l.006-1.697c.005-1.272.862-2.139 2.293-2.313.262-.032.528-.045.792-.048.677-.007 1.355-.002 2.032-.002h.202v2.252h-.266c-.435 0-.871-.003-1.307 0-.43.004-.713.26-.713.639v1.344h2.307l-.28 2.18h-2.04v6.4h-3.023v-6.4H12z",
  clipRule: "evenodd"
})));
export default SvgFacebookRedesign;